import React, { useEffect, useState } from 'react';
import logo from '../../assets/images/logo.svg';
import CountDownTimer from '../../components/ui/CountDownTimer';
import errorFace from '../../assets/images/errorFace.svg';
import { useNavigate , useLocation } from "react-router-dom";
import otpData from "../../types/otp.type";
import initChallenge from "../../services/sendOTP.service";
import DocumentsService from "../../services/documents.service";
import Swal from 'sweetalert2'
import NextButton from '../../components/ui/NextButton';
import { pageWard } from '../../utils/pageward';
import { sendEvent } from '../../utils/firebase';

function CheckCode() {
  const [sessionId, setId] = useState("");
  const navigate = useNavigate();
  const state = useLocation();

  useEffect(() => {
    sendEvent("INGRESA_PAGINA_OTP");
  }, []);

  useEffect(() => {
    if (!pageWard("NEED_TO_REGISTER_DEVICE")) {
      navigate('/')
    };
  }, [navigate]);
  
  useEffect(() => {
    DocumentsService.generateToken()
  }, []);


  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const [isActive, setIsActive] = useState(false);
  const [hideTransition, setIsHiden] = useState(false);
  const [otpCode, setCode] = useState("");
  const [isShaked, setError] = useState(false);
  const normalInput = "w-full bg-gray-50 text-center border border-gray-300 text-gray-900 text-3xl rounded-full  focus:outline-wallyBlue block p-2  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400"
  const errorInput = "w-full shakeError bg-gray-50 text-center border border-red-400 text-gray-900 text-3xl rounded-full  focus:outline-wallyBlue block p-2  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400"
  const [errorMessage, setMessage] = useState<string>("");
  const inputHandler = (e : any) => { 
    setCode(e.target.value);
    
    if (isNaN(Number(otpCode))) {
      setError(true);
      setMessage("El pin debe ser solo numérico.");
      return;
    }
    if (e.target.value.length === 6) {
      sendData(e.target.value)
    }
  };
  const sendData = (otp:string) => {
    sendEvent("INGRESA_CODIGO_OTP");
    setIsDisabled(true);
    setLoading(true);
    const data: otpData = {
      challengeName: "NEED_TO_REGISTER_DEVICE",
      deviceChallengeRespond: {
          deviceId:state.state.deviceId,
          activationCode: otp,
      },
      termOfServiceRespond: "wally_1-0-0",
      sessionId: state.state.sessionId,
      securityProfileId: "P1-Web"
    };
    initChallenge.initChallenge(data)
    .then((response: any) => {
      setIsDisabled(false);
      setLoading(false);
      localStorage.setItem('page', response.data.challengeName);
      sendEvent("OTP_VERIFICADO");
      switch(response.data.challengeName) {
        case "NEED_TO_UPLOAD_DOCUMENTS":
          return  navigate('/documentos',{
            state:{
              sessionId: response.data.sessionId,
              name: response.data.enrollmentCustomer.firstName,
              customerId: response.data.enrollmentCustomer.customerId,
            }
          });
        default:
          return  "NEED_TO_UPLOAD_DOCUMENTS";
      }
    })
    .catch((e: any) => {
      setIsDisabled(false);
      setLoading(false);
      if(e.response.data.errorCode === "enrollment.timeout"){
        Swal.fire({
          title: '¡Ooops!',
          text:e.response.data.message,
          imageUrl: errorFace,
          imageWidth: 150,
          imageHeight: 150,
          imageAlt: 'Custom image',
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
              navigate('/');
          }
        })
        return;
      } 
      Swal.fire({
        title: '¡Ooops!',
        text:e.response.data.message,
        imageUrl: errorFace,
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: 'Custom image',
      })
    });
  };
  const setDevice = () => { 
    if (otpCode.length<6) {
      setError(true);
      setMessage("El código debe tener 6 dígitos");
      return;
    }
    if (isNaN(Number(otpCode))) {
      setError(true);
      setMessage("El pin debe ser solo numérico.");
      return;
    }
    sendData(otpCode);
  
  };
  
  useEffect(() => {
    setIsActive(true);
    setTimeout(() => {
      setIsHiden(true);
    }, 1000)
  }, []);
  
  return (
    <div className="dark:bg-bgDark h-full p-3">
      <header className="w-full p-10">
        <img src={logo} className="h-12 mx-auto" alt="Wally" />
      </header>
      <div className={hideTransition ? 'transitionContainer hide' : 'transitionContainer'}>
        <div className={isActive ? 'transition show' : 'transition'}>
          <div className="layer one"></div>
          <div className="layer two"></div>
          <div className="layer three"></div>
        </div>
      </div>
      <div className="container mt-10 max-w-md mx-auto ">
        <div className={hideTransition ? 'w-full mx-auto show' : 'w-full mx-auto'}>
          <h1 className="text-2xl text-wallyGray font-semibold dark:text-white">Ingresá el código de
            validación</h1>
          <p className="text-gray-400 mt-2">Enviamos un mensaje de texto al número de celular registrado previamente.</p>
          <div className="relative mt-7">
            <input
              type="text"
              onFocus={() => setError(false)}
              onChange={inputHandler}
              maxLength={6}
              minLength={4}
              pattern="[0-9]*"
              inputMode='numeric'
              value={otpCode}
              className={isShaked ? errorInput : normalInput}
              placeholder="* * * * * *"/>
              {isShaked ? <p className="text-xs mt-2 text-center text-red-500" >{errorMessage}</p>:null}
          </div>
          <div className="relative mt-7 text-center w-full">
            <CountDownTimer sessionId={sessionId} seconds={60}/>
            <div className="mt-40">
              <NextButton
                name="VERIFICAR"
                onClick={setDevice}
                isDisabled={isDisabled}
                loading ={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckCode;
